import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { BrandLockup } from "../BrandLockup";

export function Footer() {
    const { t } = useTranslation();
    const location = useLocation();
    const isKids = location.pathname.startsWith("/kids");
    return (
        <footer className="relative py-20 px-6 bg-gradient-to-b from-white to-[#F4F6FB] border-t border-[#E5E1D8]/60" data-testid="site-footer">
            <div className="max-w-7xl mx-auto">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
                    <div className="md:col-span-5">
                        <div className="mb-5 -ml-1">
                            <BrandLockup size="sm" />
                        </div>
                        <p className="font-serif italic text-[#4A5A95] text-lg leading-snug">
                            {t("footer.tagline")}
                        </p>
                        <p className="mt-3 text-xs tracking-[0.18em] text-[#8A8786] font-serif italic">{t("footer.subtagline")}</p>
                        <p className="mt-6 text-sm text-[#5C5A59] leading-relaxed max-w-md">
                            {t("footer.description")}
                        </p>
                    </div>
                    <div className="md:col-span-3">
                        <p className="text-xs uppercase tracking-[0.22em] text-[#6B7DB8] font-semibold mb-4">{t("footer.platform")}</p>
                        <ul className="space-y-2 text-sm text-[#5C5A59]">
                            <li><a href="#story" className="hover:text-[#6B7DB8]">{t("footer.platform_story")}</a></li>
                            <li><a href="#john" className="hover:text-[#6B7DB8]">{t("footer.platform_meet_john")}</a></li>
                            <li><a href="#how" className="hover:text-[#6B7DB8]">{t("footer.platform_how")}</a></li>
                            <li><a href="#pricing" className="hover:text-[#6B7DB8]">{t("footer.platform_pricing")}</a></li>
                            <li><a href="/partners" className="hover:text-[#6B7DB8]" data-testid="footer-partners-link">{t("footer.platform_partners")}</a></li>
                        </ul>
                    </div>
                    <div className="md:col-span-4">
                        <p className="text-xs uppercase tracking-[0.22em] text-[#6B7DB8] font-semibold mb-4">{t("footer.families")}</p>
                        <ul className="space-y-2 text-sm text-[#5C5A59]">
                            <li><a href="/sign-up" className="hover:text-[#6B7DB8]">{t("footer.families_signup")}</a></li>
                            <li><a href="/sign-in" className="hover:text-[#6B7DB8]">{t("footer.families_signin")}</a></li>
                            <li><a href="#waitlist" className="hover:text-[#6B7DB8]">{t("footer.families_waitlist")}</a></li>
                            <li><a href="mailto:hello@remembr.it.com" className="hover:text-[#6B7DB8]">{t("footer.families_email")}</a></li>
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-[#E5E1D8]/60 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#8A8786]">
                    <p>{t("footer.copyright", { year: new Date().getFullYear() })}</p>
                    <p className="italic">{t(isKids ? "footer.charity_line_kids" : "footer.charity_line")}</p>
                </div>
            </div>
        </footer>
    );
}
